import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

const DiceDreamsCheckoutSkeleton = () => {
  return (
    <section className="w-full mb-[20px] mt-[17px] px-5 flex justify-between items-center">
      <Skeleton className="h-[20px] w-[120px]" />
      <Skeleton className="w-[22px] h-[22px] rounded-md" />
    </section>
  );
};

export default React.memo(DiceDreamsCheckoutSkeleton);
